export default {
  previewNotifications: [],
  notifications: [],
  notification: undefined,
};
